module.exports = __webpack_public_path__ + "img/top_banner.19ada9f1.jpg";